import React from 'react';
import { useDataValue } from 'globals/contexts/dataContext';

import { Link, generatePath } from 'react-router-dom';
import routes from 'globals/routes';

import './landingSection.css';
import './landingSectionMobile.css';

const LandingSection = (props) => {
  const pageContent = props['content'];
  const [{content, currentLanguage}, dispatch] = useDataValue();
  const logoUrl = content['logo'];

  return <section className="landing" id="landing">
    <div className="logo">
      <Link to={generatePath(routes.indexPage, {lang: currentLanguage})}>
        <img src={logoUrl} />
      </Link>
    </div>
    {pageContent['introduction'].map((content, idx) => {
      return <div key={idx}
        className={`introduction verticalText ${content['language']} ${content['language'] === currentLanguage? 'mobile': ''}`}
        dangerouslySetInnerHTML={{
          __html: content['text']
      }} />;
    })}
    <div className="decorateLine" />
    <div className="scrollHints" dangerouslySetInnerHTML={{
      __html: pageContent['scrollHints']
    }} />
    <div className="coverMedia">
    {/* https://www.robinwieruch.de/conditional-rendering-react */}
    {{
      image: <img src={pageContent['cover']['src']} />,
      video: <video src={pageContent['cover']['src']} autoPlay playsInline muted loop />,
    }[pageContent['cover']['type']]}
    </div>
  </section>;
}

export default LandingSection;